<template>
  <el-row :gutter="30" v-if="acquired">
    <el-col :span="24" class="alignCenter">
      <el-input
        type="textarea"
        placeholder="请输入内容"
        :rows="10"
        v-model="prescription"
      ></el-input>
      <el-button
        type="primary"
        size="medium"
        @click="_updateExamPrescription"
        class="fullWidth"
        v-show="!disabled"
        >保存</el-button
      >
    </el-col>
  </el-row>

  <div v-else>
    <el-alert
      title="暂无"
      type="info">
    </el-alert>
  </div>
</template>

<script>
import { ExamStatesValue } from "../../utils/constants";
import { Util_updateExamState } from "../../utils/util";
import { getUserExam } from "../../api/userService";
import {
  updateExamPrescription,
  updateExamState,
} from "../../api/userExamService";

export default {
  props: {
    examUuid: String,
    disabled: Boolean,
  },
  data() {
    return {
      prescription: "",
      acquired:false,
    };
  },
  methods: {
    _getPrescription() {
      getUserExam(this.examUuid)
        .then((res) => {
          console.log("Prescription",res);
          if(res.data[0].prescription !="") {
            this.prescription = res.data[0].prescription;
            this.acquired = true;
          }
          else{
            this.acquired = false;
          }
        })
        .catch((e) => {
          console.log("getUserExam", e);
        });
    },
    _updateExamState(state, reloadFunc) {
      //如果已到达，则将其状态改为30:基础问询中
      Util_updateExamState(
        this.examUuid,
        state,
        updateExamState,
        reloadFunc,
        this.$message
      );
    },
    //保存 医嘱
    _updateExamPrescription() {
      let data = {
        prescription: this.prescription,
      };
      updateExamPrescription(this.examUuid, data)
        .then((res) => {
          if (res.success) {
            this._updateExamState(
              ExamStatesValue.FEED_BACK_80,
              this._getPrescription
            );
            this.$message({
              message: res.description,
              type: "success",
            });
          } else {
            this.$message({
              message: res.description,
              type: "warning",
            });
          }
        })
        .catch((e) => {
          this.$message({ message: e, type: "error" });
        });
    },
  },
  created() {
    this._getPrescription();
  },
};
</script>

<style scoped lang=less>
.fullWidth {
  margin-top: 15px;
  width: 100%;
}
</style>